import React from 'react';
import { StyledStars, StyledStarsInput, StyledStarLabel } from './stars.style';

const Stars = ({ rank, setRank }) => {
	const changeStarsRatingHandler = (e) => {
		const newRank = e.target.value;
		setRank(newRank);
	};

	const renderStars = () => {
		let maxStars = 5;
		let stars = [],
			checked;

		for (let i = maxStars; i > 0; i--) {
			if (i <= parseInt(rank)) {
				checked = true;
			} else {
				checked = false;
			}

			stars.push(
				<StyledStarLabel key={i} checked={checked} onChange={(e) => changeStarsRatingHandler(e)}>
					<StyledStarsInput type='radio' name='rating' value={i} />
				</StyledStarLabel>,
			);
		}
		return stars;
	};
	return <StyledStars>{renderStars()}</StyledStars>;
};

export default Stars;
